// @flow
/** @jsx h */

/* eslint-disable jsx-a11y/media-has-caption, promise/always-return */

import { h, Component } from 'preact'

type Props = {
  className?: string,
  autoPlay?: boolean,
  poster: string,
  sources: {
    mp4: string,
    webm: string
  },
  onAutoPlay?: Function
}

export class HTML5Video extends Component<Props> {
  elm: HTMLVideoElement

  componentDidMount () {
    const { autoPlay, onAutoPlay } = this.props

    if (autoPlay && onAutoPlay) {
      this.elm.addEventListener('timeupdate', this.handleTimeupdate)
    }
  }

  componentWillUnmount () {
    const { autoPlay, onAutoPlay } = this.props

    if (autoPlay && onAutoPlay) {
      this.elm.removeEventListener('timeupdate', this.handleTimeupdate)
    }
  }

  handleTimeupdate = () => {
    const { onAutoPlay } = this.props

    if (onAutoPlay) {
      onAutoPlay(true)
      this.elm.removeEventListener('timeupdate', this.handleTimeupdate)
    }
  }

  render () {
    const { sources, ...rest } = this.props
    return (
      <video {...rest} disableRemotePlayback x-webkit-airplay='deny' ref={elm => (this.elm = elm)}>
        <source src={sources.webm} type='video/webm' />
        <source src={sources.mp4} type='video/mp4' />
        Nettleseren din støtter ikke video.
      </video>
    )
  }
}



// WEBPACK FOOTER //
// ./src/v1/lib/components/HTML5Video.js